import useDealer from "hooks/useDealer";
import DealerPayments from "views/Dealers/Tabs/DealerPayments";

// core components
import PageLayout from "layouts/PageLayout";

export default function DealerPaymentsView({ ...otherProps }) {
    const dealer = useDealer();

    return (
        <PageLayout {...otherProps}>
            <DealerPayments dealer={dealer} dlid={dealer.id} />
        </PageLayout>
    );
}
